export default "__VITE_ASSET__DzblCOCQ__"